import Reveal from "@/components/base/Reveal";
import SectionHead from "@/components/base/SectionHead";
import { eliminateEvents } from "@/mocks/dailyContest";

export default function Eliminate() {
  return (
    <section id="eliminate" className="border-b border-background-300/70 bg-background-50 py-12 md:py-16">
      <div className="container-x">
        <Reveal>
          <SectionHead
            eyebrow="淘汰内幕 · 规则复盘"
            title="每一次淘汰背后，规则都说了算"
            desc="名单泄露、加赛、剪辑缩水与复活条款——我们把历届争议事件与对应的赛制条文做成一条可回放的时间线。"
          />
        </Reveal>

        <div className="relative mt-10 grid gap-6 lg:grid-cols-2">
          {/* vertical line on desktop */}
          <div
            aria-hidden="true"
            className="absolute inset-y-0 left-[15px] hidden w-px bg-gradient-to-b from-primary-300 via-secondary-300 to-accent-300 lg:block"
          />
          {eliminateEvents.map((ev, i) => (
            <Reveal key={`${ev.round}-${ev.title}`} delay={i * 60} className={i % 2 === 1 ? "lg:pl-20" : "lg:pr-20"}>
              <div className="relative flex items-start gap-4">
                <span className="relative z-10 hidden h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-600 text-xs font-black text-background-50 ring-4 ring-background-50 lg:flex">
                  <i className="ri-vip-crown-line" aria-hidden="true" />
                </span>
                <article className="flex-1 rounded-lg border border-background-300/70 bg-background-100 p-5 transition-colors hover:border-primary-300 md:p-6">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <span className="chip bg-primary-600 text-background-50">{ev.round}</span>
                    <span className="flex items-center gap-1 text-xs font-medium text-foreground-500">
                      <i className="ri-time-line" aria-hidden="true" />
                      {ev.date}
                    </span>
                  </div>
                  <h3 className="mt-3 font-serif text-lg font-bold text-foreground-950">{ev.title}</h3>
                  <p className="mt-2 text-[13px] leading-6 text-foreground-600">{ev.desc}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-300/60 pt-3">
                    <span className="chip bg-secondary-100 px-2.5 py-0.5 text-secondary-800">
                      <i className="ri-price-tag-3-line mr-1" aria-hidden="true" />
                      {ev.tag}
                    </span>
                    <span className="text-xs font-semibold text-primary-600">赛程档案 · #{String(i + 1).padStart(2, "0")}</span>
                  </div>
                </article>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex items-center gap-3 rounded-lg border border-secondary-300 bg-secondary-50 px-5 py-4">
            <i className="ri-archive-line text-xl text-secondary-700" aria-hidden="true" />
            <p className="text-[13px] leading-6 text-foreground-700">
              以上为站内按公开信息整理的赛程档案，标注了性质与来源。想了解保送、复活与加权条款的白话解释，
              请见
              <a href="#faq" className="mx-1 font-bold text-primary-600 hover:text-primary-700">规则常见问题</a>
              。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}